import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import SliderWrapper from '../slider-wrapper/SliderWrapper';
import FontIconCards from '../card-groups/FontIconCards';
import FontIconFeatureCards from '../card-groups/FontIconFeatureCards';
var FontIconCardsSlider = /*#__PURE__*/function (_React$Component) {
  function FontIconCardsSlider() {
    _classCallCheck(this, FontIconCardsSlider);
    return _callSuper(this, FontIconCardsSlider, arguments);
  }
  _inherits(FontIconCardsSlider, _React$Component);
  return _createClass(FontIconCardsSlider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cardsPerSlide = _this$props.cardsPerSlide,
        featured = _this$props.featured;
      var splitArrayIntoChunks = function splitArrayIntoChunks(cards) {
        var firstChunkSize = 0;
        if (featured) {
          if (cardsPerSlide === 3) {
            firstChunkSize = cardsPerSlide - 1;
          } else {
            firstChunkSize = 4;
          }
        }
        var chunkSize = cardsPerSlide;
        var chunks = [];
        var index = 0;
        // Create the first chunk with the featured card and the first 4 or 2 regular cards
        if (firstChunkSize > 0) {
          chunks.push(cards.slice(index, index + firstChunkSize));
          index += firstChunkSize;
        }
        // Create the remaining chunks with up to 6 regular cards each
        while (index < cards.length) {
          chunks.push(cards.slice(index, index + chunkSize));
          index += chunkSize;
        }
        return chunks;
      };
      var cardChunks = splitArrayIntoChunks(this.props.cards);
      return React.createElement(React.Fragment, null, cardChunks.length > 1 ? React.createElement(SliderWrapper, {
        className: "cards-slider ".concat(this.props.className || ''),
        settings: _objectSpread({
          lazyLoad: undefined
        }, this.props.sliderSettings)
      }, cardChunks.map(function (chunk, i) {
        if (i === 0 && featured) {
          return React.createElement(FontIconFeatureCards, {
            cards: chunk,
            featured: featured,
            key: "".concat(i, "-featured-card"),
            cardsPerPage: cardsPerSlide === 3 ? 3 : 5
          });
        }
        return React.createElement(FontIconCards, {
          key: "".concat(i, "-cards-slider-wrp"),
          cards: chunk,
          cardsPerPage: cardsPerSlide
        });
      })) : React.createElement(React.Fragment, null, featured ? React.createElement(FontIconFeatureCards, {
        cards: cardChunks[0],
        featured: featured,
        cardsPerPage: cardsPerSlide === 3 ? 3 : 5
      }) : React.createElement(FontIconCards, {
        cards: cardChunks[0],
        cardsPerPage: cardsPerSlide
      })));
    }
  }]);
}(React.Component);
export { FontIconCardsSlider as default };